<template>
  <b-container class="room">
    <b-row class="room-name">
      <b-col><h3>Sala <b>{{room.name}}</b></h3></b-col>
    </b-row>
    <!-- Access code -->
    <b-row v-if="locked && room.private" align-h="center">
      <b-col md="6">
        <b-input v-model="code" placeholder="Código de Acceso"></b-input>
      </b-col>
    </b-row>
    <b-row v-if="locked" align-h="center" class="margin-top">
      <b-col md="6">
        <b-button variant="primary" class="w-100" @click="unlockRoom">Unirse a la Sala</b-button>
      </b-col>
    </b-row>
    <b-row v-if="wrongPassword" align-h="center" class="margin-top">
      <b-col md="6">
        <b-alert v-model="wrongPassword" variant="danger" dismissible>
          El código de acceso es incorrecto!
        </b-alert>
      </b-col>
    </b-row>
    <!-- Member list -->
    <b-row v-if="!locked">
      <b-col lg="6">
        <b-card no-body header="Miembros" class="card-list">
          <b-list-group flush>
            <b-list-group-item
              v-for="member in memberData" v-bind:key="member.uid"
              class="d-flex justify-content-between align-items-center">
              <span>
                {{ member.username || member.displayName }}
              </span>
              <span>
                <span v-if="isMe(member.uid) && !isMe(room.userId)">
                  <b-badge variant="primary"><b-icon icon="person-fill"></b-icon></b-badge>
                </span>
                <span v-if="isMe(member.uid) && isMe(room.userId)">
                  <b-badge variant="primary">Admin <b-icon icon="person-fill"></b-icon></b-badge>
                </span>
                <span v-if="room.userId === member.uid && !isMe(member.uid)">
                  <b-badge variant="primary">Admin</b-badge>
                </span>
                <span class="balance">
                  <b-badge :variant="getBalanceVariant(member.balance)">{{member.balance}}€</b-badge>
                </span>
              </span>
            </b-list-group-item>
            <b-list-group-item class="text-center show-all" @click="showAllMembers = !showAllMembers" v-if="members.length > 5">
              Mostrar <span v-if="!showAllMembers">todos</span><span v-if="showAllMembers">menos</span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
      <!-- Games list -->
      <b-col lg="6">
        <b-card no-body header="Partidas" class="card-list">
          <b-list-group flush>
            <b-list-group-item v-if="games.length === 0">
              No se ha creado ninguna partida
            </b-list-group-item>
            <b-list-group-item class="text-left d-flex w-100 justify-content-between clickable" v-for="game in gamesData" v-bind:key="game.uid" @click="goToGame(game.id)">
              <div align-v="center">
                <span>{{ game.name }}</span><br/>
                <b-badge :variant="getBadgeInfo(game).variant">{{ getBadgeInfo(game).message }}</b-badge>
              </div>
              <div class="text-right">
                <small>Línea {{ getLinePrize(game) }}€</small><br/>
                <small>Bingo {{ getBingoPrize(game) }}€</small>
              </div>
            </b-list-group-item>
            <b-list-group-item class="text-center show-all" @click="showAllGames = !showAllGames" v-if="games.length > 5">
              Mostrar <span v-if="!showAllGames">todos</span><span v-if="showAllGames">menos</span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="actions">
          <b-button class="w-100" @click="showCreateGame = true" variant="success" v-if="isMe(room.userId)">Crear Partida</b-button>
          <b-button class="w-100" @click="paymentsDialog = true" variant="light">Mostrar pagos</b-button>
          <b-button class="w-100" @click="clearRoomDialog = true" variant="warning" v-if="isMe(room.userId)" :disabled="games.length === 0">Reiniciar Sala</b-button>
          <b-button class="w-100" @click="deleteRoomDialog = true" variant="danger" v-if="isMe(room.userId)">Eliminar Sala</b-button>
        </div>
      </b-col>
    </b-row>
    <!-- New Game -->
    <b-row align-v="center" align-h="center" class="overlay" v-if="showCreateGame">
      <b-col lg="5" md="6">
        <b-form @submit="submitCreateGame">
          <b-card title="Nueva Partida" class="card">
            <b-form-group>
              <b-form-input
                v-model="newGame.name"
                required
                placeholder="Nombre"
                class="text-center"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Precio por cartón">
              <b-input-group append="€">
                <b-form-input class="text-center" type="number" min="0" step="0.01" v-model="newGame.costPerTicket" required></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              Repartición de premios
              <b-input-group prepend="0" append="100" class="mt-3">
                <b-form-input required type="range" min="0" max="100" v-model="newGame.prizesDistribution"></b-form-input>
              </b-input-group>
              <b-button-group class="prices">
                <b-button variant="light" disabled>Línea: {{ newGame.prizesDistribution }}%</b-button>
                <b-button variant="light" disabled>Bingo: {{ 100 - newGame.prizesDistribution }}%</b-button>
              </b-button-group>
            </b-form-group>
            <b-button class="bottom" @click="showCreateGame = false" variant="danger">Cancelar</b-button>
            <b-button type="submit" class="bottom" variant="primary">Crear Partida</b-button>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
    <!-- Reset Room -->
    <b-row align-v="center" align-h="center" class="overlay" v-if="clearRoomDialog">
      <b-col lg="5" md="6">
        <b-card title="¿Estás seguro?" class="card">
          <p>Esto borrará todas las partidas y el balance hasta la fecha</p>
          <b-button class="bottom" @click="clearRoomDialog = false" variant="primary">Cancelar</b-button>
          <b-button class="bottom" @click="clearRoom" variant="danger">Sí, Reiniciar Sala</b-button>
        </b-card>
      </b-col>
    </b-row>
    <!-- Delete Room -->
    <b-row align-v="center" align-h="center" class="overlay" v-if="deleteRoomDialog">
      <b-col lg="5" md="6">
        <b-card title="Eliminar Sala" class="card">
          <p>¿Estás seguro?</p>
          <b-button class="bottom" @click="deleteRoomDialog = false" variant="primary">Cancelar</b-button>
          <b-button class="bottom" @click="deleteRoom" variant="danger">Sí, Eliminar Sala</b-button>
        </b-card>
      </b-col>
    </b-row>
    <!-- Payments -->
    <b-row align-v="center" align-h="center" class="overlay" v-if="paymentsDialog">
      <b-col lg="5" md="6">
        <b-card title="Pagos" class="card">
          <b-card-text class="text-normal" v-for="(payment, idx) in getPayments()" :key="idx">
            <b>{{ payment.giver }}</b> debe <b>{{ parseFloat(payment.amount).toFixed(2) }}€</b> a <b>{{ payment.receiver }}</b>
          </b-card-text>
          <b-button class="bottom" @click="paymentsDialog = false" variant="primary">Cerrar</b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
const fb = require("../firebaseConfig.js");

export default {
  name: "room",
  data() {
    return {
      room: {
        members: []
      },
      code: '',
      members: [],
      games: [],
      newGame: {
        prizesDistribution: 30,
        costPerTicket: 0.5
      },
      wrongPassword: false,
      showCreateGame: false,
      showAllMembers: false,
      showAllGames: false,
      clearRoomDialog: false,
      deleteRoomDialog: false,
      paymentsDialog: false,
    };
  },
  computed: {
    locked() {
      return this.room.members.indexOf(fb.auth().currentUser.uid) === -1;
    },
    memberData() {
      let members = [...this.members];
      members.sort((a, b) => b.balance - a.balance);
      if (this.showAllMembers) {
        return members;
      } else {
        return members.slice(0,5);
      }
    },
    gamesData() {
      if (this.showAllGames) {
        return this.games;
      } else {
        return this.games.slice(0,5);
      }
    }
  },
  watch: {
    room: {
      handler(room, oldRoom) {
        if (room.members.toString() != oldRoom.members.toString()) {
          fb.usersCollection.get()
          .then((querySnapshot) => {
            let members = [];
            querySnapshot.forEach((member) => {
              let memberData = member.data();
              if (room.members.indexOf(memberData.uid) > -1) {
                members.push({...memberData, balance: this.getBalance(memberData.uid)})
              }
            });
            this.members = members;
          });
        }
      },
      deep: true
    }
  },
  firestore() {
    return {
      room: fb.roomsCollection.doc(this.$route.params.roomId),
      // TODO: Move games to beforeCreate
      games: fb.gamesCollection.where("roomId", "==", this.$route.params.roomId).orderBy("creationDate", "desc")
    };
  },
  methods: {
    deleteRoom() {
      this.$unbind('room', false);
      fb.roomsCollection.doc(this.$route.params.roomId).delete().then(() => {
        this.$router.push({name: 'rooms-list'})
      })
    },
    clearRoom() {
      this.games.forEach(game => {
        fb.gamesCollection.doc(game.id).delete()
        .then(() => {
          this.resetBalance();
        })
        .catch((err) => console.error(err))
      });
      this.clearRoomDialog = false;
    },
    resetBalance() {
      this.members.forEach(member => {
        member.balance = "0.00";
      })
    },
    getBadgeInfo(game) {
      if (game.numbers.length === 0) {
        return {
          variant: "success",
          message: "Disponible"
        }
      } else if (game.numbers.length && !game.bingoClaims.length) {
        return {
          variant: "warning",
          message: "En juego"
        }
      } else if (game.numbers.length && game.bingoClaims.length) {
        return {
          variant: "danger",
          message: "Finalizado"
        };
      }
    },
    getBingoPrize(game) {
      return game.assignedTickets.length ? (game.assignedTickets.length * game.costPerTicket) * (100 - game.prizesDistribution) / 100 : 0;
    },
    getLinePrize(game) {
      return game.assignedTickets.length ? (game.assignedTickets.length * game.costPerTicket) * (game.prizesDistribution) / 100 : 0;
    },
    getMemberDisplayInfo() {
      return fb.roomsCollection.doc(this.$route.params.roomId)
    },
    isMe(userId) {
      return userId === fb.auth().currentUser.uid;
    },
    getBalanceVariant(balance) {
      if (balance > 0) {
        return "success";
      } else if (balance < 0) {
        return "danger";
      } else {
        return "secondary";
      }
    },
    getBalance(userId) {
      let balance = 0;
      let playedGames = this.games.filter(game => {
        return game.participantIds.indexOf(userId) > -1;
      });
      playedGames.forEach(game => {
        let won = 0;

        let myassignedTickets = game.assignedTickets.filter(assignedCard => assignedCard.userId === userId).length;
        let spent = game.costPerTicket * myassignedTickets;

        let lineClaims = game.lineClaims.length;
        let myLineClaims = game.lineClaims.filter(claim => claim.userId === userId).length;
        if (myLineClaims > 0) {
          won += this.getLinePrize(game) / lineClaims;
        }

        let bingoClaims = game.bingoClaims.length;
        let myBingoClaims = game.bingoClaims.filter(claim => claim.userId === userId).length;
        if (myBingoClaims > 0) {
          won += this.getBingoPrize(game) / bingoClaims;
        }

        balance += won - spent;
      });
      return balance.toFixed(2);
    },
    getPayments() {
      let sortedMembers = [...this.members];
      sortedMembers.sort((a, b) => b.balance - a.balance);

      let payments = [];
      let positiveBalances = [];
      let negativeBalances = [];

      // Separate positive and negative balances
      // For some reason ... doesn't clone 
      sortedMembers.forEach(member => {
        if (member.balance > 0) {
          positiveBalances.push({
            uid: member.uid,
            displayName: member.displayName,
            balance: parseFloat(member.balance)
          })
        }
      });
      sortedMembers.forEach(member => {
        if (member.balance < 0) {
          negativeBalances.push({
            uid: member.uid,
            displayName: member.displayName,
            balance: parseFloat(member.balance)
          })
        }
      });
      
      // For each negative balance
      for (let i = negativeBalances.length; i--;) {
        for (let x = 0; x < positiveBalances.length; x++) {
          if (parseFloat(positiveBalances[x].balance) === 0) {
            continue;
          }
          let amount = 0;
          let positiveBalance = positiveBalances[x].balance;
          let absoluteNegativeBalance = -negativeBalances[i].balance;
          if (positiveBalance > absoluteNegativeBalance) {
            amount = absoluteNegativeBalance;
          } else {
            amount = positiveBalance
          }
          payments.push({
            giver: negativeBalances[i].displayName,
            receiver: positiveBalances[x].displayName,
            amount: amount
          });
          positiveBalances[x].balance = parseFloat(positiveBalances[x].balance - amount);
          negativeBalances[i].balance = parseFloat(negativeBalances[i].balance + amount);
          if (negativeBalances[i].balance >= 0) {
            break;
          }
        }
      }
      return payments;
    },
    unlockRoom() {
      if (this.code === this.room.password) {
        this.wrongPassword = false;
        fb.roomsCollection.doc(this.$route.params.roomId)
        .update({
          members: [...this.room.members, fb.auth().currentUser.uid]
        })
        .catch((err) => {
          console.error(err)
        })
      } else {
        this.wrongPassword = true;
      }
    },
    submitCreateGame(evt) {
      evt.preventDefault();
      this.createGame();
    },
    goToGame(gameId) {
      this.$router.push({
        name: 'game',
        params: {
          roomId: this.$route.params.roomId,
          gameId
        }
      })
    },
    createGame() {
      fb.gamesCollection.add({
        name: this.newGame.name,
        userId: fb.auth().currentUser.uid,
        participantIds: [],
        costPerTicket: this.newGame.costPerTicket,
        prizesDistribution: this.newGame.prizesDistribution,
        roomId: this.room.id,
        assignedTickets: [],
        lineClaims: [],
        bingoClaims: [],
        numbers: [],
        pool: Array.from({ length: 90 }, (v, k) => k + 1),
        status: 'open',
        creationDate: new Date(),
      })
      .then((ref) => {
        this.newGame.id = ref.id;
        ref.update({
          id: ref.id
        })
        .then(() => {
          this.showCreateGame = false;
          this.goToGame(this.newGame.id);
        })
      })
      .catch((err) => {
        console.error(err)
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.margin-top {
  margin-top: 20px;
}
.overlay {
  position: fixed;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.room {
  text-align: center;
  padding-bottom: 30px;
}
.card-list {
  margin-bottom: 10px;
}
.card {
  .bottom {
    margin: 0 5px;
  }
  .prices {
    width: 100%;
  }
}
.room-name {
  padding-top: 20px;
  padding-bottom: 20px;
}
.balance {
  margin-left: 5px;
}
.actions {
  button {
    margin-top: 10px;
  }
}
</style>